/**
 * If changing the page paths, remember to change the folder name in the app folder as well.
 */
export const ARTICLES_PAGE_PATH = '/blogg';

export const SITE_NAME = 'Kvinnehelseklinikken';
